<template>
    <div class="w-full max-w-screen-md">
        <transition name="fade" mode="out-in">            
                <div v-if="transferState == 'confirm'" class="mn3-content p-2 rounded-sm">
                    <p>
                        <span>ACH Origination Transfer: </span> <span class="font-bold">{{formatMoney(transferDisplayAmount)}}</span> 
                        from <span class="font-bold">SHARE-1</span> 
                        to <span v-if="toDisplayAccountType == 'External'" class="font-bold">DRAFT-1</span>  
                            <span v-else class="font-bold"></span>                        
                    </p>
                    <span v-if="showPrincipalPayment && principalPayment == true" class="mn3-alert px-2 rounded-sm flex flex-row items-center justify-center">
                        <Icon id="exclamation" class="h-6 w-6 mr-2" /><span>Making a Principal Only Payment</span>
                    </span>
                    <div v-if="fv.tranNote.value != ''"
                        class="mn3-content-alt p-1 rounded-sm mb-2">Transfer Note: {{fv.tranNote.value}}</div>
                    <div class="flex w-full justify-center items-center mb-6 mt-5">
                        <div class="border rounded">
                            <div class="border-b p-2 font-bold">SHARE-1</div>
                            <div class="px-4 pt-2 line-through text-center opacity-80">{{formatMoney(transferDisplayAmountBeforeFrom)}}</div>
                            <div class="px-4 font-bold text-xl text-center">{{formatMoney(transferDisplayAmountAfterFrom)}}</div>
                            <div class="px-4 pb-2 text-sm text-center">Balance after Transfer</div>
                        </div>
                        <div class="flex flex-col items-center justify-center">
                            <div class="flex flex-col items-center mx-5 h-20 w-20 border rounded-full p-2">
                                <Icon id="arrow-right" class="h-10 w-10" />
                                <div class="borber rounded font-bold text-sm">{{formatMoney(transferDisplayAmount)}}</div>
                            </div>
                        </div>
                        <div v-if="toDisplayAccountType == 'LineOfCredit'|| toDisplayAccountType == 'CreditCard'"
                            class="border rouned">                            
                            <div class="border-b p-2 font-bold">DRAFT-1</div>
                            <div class="px-4 pt-2 line-through text-xl text-center opacity-80">{{formatMoney(transferDisplayAmountBeforeTo)}}</div>
                            <div class="px-4 pb-2 text-sm text-center font-bold">Payment of {{formatMoney(transferDisplayAmount)}}</div>
                        </div>
                        <div v-else-if="toDisplayAccountType == 'CC'"
                            class="border rouned">                            
                            <div class="border-b p-2 font-bold">Credit Card Payment</div>
                            <div class="px-4 pb-2 text-sm text-center font-bold mt-2">Payment will be made on your behalf</div>
                        </div>
                        <div v-else-if="toDisplayAccountType == 'Check'"
                            class="border rouned">                            
                            <div class="border-b p-2 font-bold">DRAFT-1</div>
                            <div class="px-4 pb-2 text-sm text-center font-bold mt-2">Check Will Be Sent to Address On File</div>
                        </div>
                        <div v-else-if="toDisplayAccountType == 'External'"
                            class="border rouned">                            
                            <div class="border-b p-2 font-bold w-64">DRAFT-1</div>
                            <div class="px-4 pb-2 text-sm text-center font-bold mt-2">Transfering to an external account</div>
                        </div>
                        <div v-else
                            class="border rounded">
                            <div class="border-b p-2 font-bold">DRAFT-1</div>
                            <div class="px-4 pt-2 line-through text-center opacity-80">{{formatMoney(transferDisplayAmountBeforeTo)}}</div>
                            <div class="px-4 font-bold text-xl text-center">{{formatMoney(transferDisplayAmountAfterTo)}}</div>
                            <div class="px-4 pb-2 text-sm text-center">Balance after Transfer</div>
                        </div>
                    </div>
                    <!-- CC Notice -->
                    <div v-if="ccPaymentConfirmMessage && toDisplayAccountType == 'CreditCard'"
                        class="mn3-content border mx-auto my-5 rounded-sm w-5/6 px-4 cc-notice" v-html="ccPaymentConfirmMessage" />
                    <div class="flex w-full p-2">
                        <Button 
                            class="flex-grow"
                            size="large"
                            type="submit"
                            @click="transferState = 'default'"
                            label="Submit Transfer" />
                        <Button 
                            class="ml-1"
                            size="large"
                            type="cancel"
                            @click="transferState = 'default'"
                            label="Cancel" />
                    </div>
                </div>
                       
            <Form v-else
                title="ACH Origination Transfer Funds"
                submitText="Submit Request"
                class="w-full"
                :error="error"
                @submit="goToConfirm"
                :showCancel="false">
                <div class="w-full text-center mb-2">
                    <div :class="`w-full flex flex-row items-center justify-center text-center md:max-w-screen-sm mx-auto md:rounded overflow-hidden`">
                        <img src="@/assets/img/ach-check.jpg" class="mx-auto" style="max-height: 175px"/>
                    </div>
                </div>

                <div class="w-full flex flex-row items-center">
                    <Field label="Transfer Type"
                        type="select"
                        :options="modes"
                        :formValue="fv.mode"
                        :class="fv.mode.value == 'loan' ? 'w-1/2' : 'w-full'" />
                    <Field v-if="fv.mode.value == 'loan'" 
                        label="Loan Payment Type"
                        type="select"
                        class="w-1/3 flex-grow"
                        :options="[
                            { label: 'Interest and Principal', value: 'both' },
                            { label: 'Interest Only', value: 'int' },
                            { label: 'Principal Only', value: 'prin' },
                        ]"
                        :formValue="fv.paymentType" />
                </div>
                <Field label="My Account"
                    :desc="fv.mode.value == 'deposit' ? 'This is the account the money will be deposited to.' : 'This is the account the money will be withdrawn from.'"
                    type="select"
                    :options="optionsFrom"
                    :formValue="fv.fromAccountId" />
                <Field label="External Account"
                    type="select"
                    :options="optionsTo"
                    :formValue="fv.toAccountId" />               
                <Field v-if="fv.toAccountId.value == 'new'" 
                    label="9 Digit Routing and Transit Number"  
                    class="text-lg"             
                    type="number"
                    maxLength="9"
                    :formValue="fv.accountOtherRouting" />
                <Field v-if="fv.toAccountId.value == 'new'" 
                    label="Checking Account Number"  
                    class="text-lg"             
                    type="number"
                    :formValue="fv.accountOtherAccount" />
                <Field v-if="fv.toAccountId.value == 'new'" 
                    label="Checking Account Number (Confirm)"  
                    class="text-lg"             
                    type="number"
                    :formValue="fv.accountOtherAccountConfirm" />
                <Field v-if="fv.toAccountId.value == 'new'" 
                    label="Account Nickname"  
                    class="text-lg"             
                    type="text"
                    :formValue="fv.accountOtherNickname" />
                <Field v-if="fv.toAccountId.value == 'new'" 
                    label="Save this account for future transfers"  
                    class="text-lg"             
                    type="toggle"
                    :formValue="fv.accountOtherSave" />
                <div class="flex flex-row" v-if="fv.toAccountId.value == 'saved'" >
                    <Field 
                        class="flex-grow"
                        type="select"
                        :formValue="fv.addressTo"
                        label="Address Book Account"
                        :options="[
                            { label: '', value: '' },
                            { label: 'Person McPerson (Acct# 24) RTN 135879614', value: '0' },
                            { label: 'George Georgie (Acct# 0015487) RTN 00001234567', value: '1' },
                            { label: 'Person McPerson SH (Acct# 124) RTN 135879614', value: '2' }
                        ]" />
                    <div class="flex flex-col justify-center">
                        <Button
                            @click="stateSave();this.$router.push('/settings?sub_menu=addresses&return=ach')"
                            icon="book-open" 
                            class="mx-2 mt-1" 
                            label="Edit Saved Addresses" />
                    </div>
                </div> 
                
                <Field 
                    label="Transfer Amount (In USD$)"  
                    class="text-lg flex-grow"             
                    type="text"
                    textFormat="amount"
                    align="left"
                    :formValue="fv.amount" />
                    
                <Field
                    label="How Often Should this Transaction Occur?"
                    type="select"
                    :options="[
                        { label: 'One Time Only', value: 'once' },
                        { label: 'Weekly', value: 'week' },
                        { label: 'Bi-Weekly', value: 'biweek' },
                        { label: 'Monthly', value: 'month' },
                        { label: 'Quarterly', value: 'quarter' },
                        { label: 'Semi-Annually', value: 'semiannual' },
                        { label: 'Annually', value: 'annual' },
                    ]"
                    :formValue="fv.freq" />                    
                <Field 
                    v-if="fv.freq.value != 'once'"
                    label="Starting On"  
                    class="text-lg flex-grow"             
                    type="date"
                    align="left"
                    :formValue="fv.freqStartDate" />

            </Form>
        </transition>
    </div>
</template>
<script>
import { useRouter } from "vue-router"
import { ref } from "vue";
import Button from '@/components/Button.vue'
import Field from '@/components/Field.vue'
import Form from '@/components/Form.vue'

export default{
    components: {
        Button,
        Field,
        Form
    },
    mounted(){
        this.fetchTransferOptions();
        document.title = "ACH Origination";
    },
    created(){
            if(this.$route.query.restore == '1'){
                this.stateLoad()
            }
    },
    computed:{
    /* Dropdown options for the from account */
        optionsFrom(){                
            let options = [];
            for(var ii = 0; ii < this.fromAccountIds.length; ii++){
                let key = this.fromAccountIds[ii]
                let acct = this.accounts[key]     
                let group = acct.ownerName

                let bal = '';
                if(acct.availableBalance){
                    bal = ` • Avail Bal: ${this.formatMoney(acct.availableBalance)}`;
                    if(acct.type == 'CreditCard' || acct.type == 'Loan' || acct.type == 'LineOfCredit' || acct.type == 'Mortgage'){
                        bal = ` • Current Bal: ${this.formatMoney(acct.actualBalance)}`;
                    }
                }

                options.push({
                    label: `${acct.type}: ${acct.displayAccountId} • ${(acct.nickname != undefined) ? acct.nickname : acct.description}${bal}`,
                    value: key,
                    group: group
                })
            }	
            
            return options;
        },
        /* Dropdown options for the to account */
        optionsTo(){
            let options = [];
            options.push({label: '', value: ''});
            options.push({label: 'Enter New Account', value: 'new'});
            options.push({label: 'Account From Address Book', value: 'saved'});

            return options;
        },
    },
    methods:{
        
            stateLoad(){
                let state = localStorage.getItem('ach-state');
                console.log('stateLoad: ', JSON.parse(state))
                if(state){
                    state = JSON.parse(state)
                    if(state){
                    this.fv.fromAccountId.value = state.fromAccount
                    this.fv.toAccountId.value = state.toAccount
                    this.fv.tranNote.value = state.note
                    this.fv.amount.value = state.amount
                    }
                }
                localStorage.setItem('ach-state', null);
            },
            stateSave(){
                let state = {
                    fromAccount: this.fv.fromAccountId.value,
                    fromAddressBook: '',
                    toAccount: this.fv.toAccountId.value,
                    toAddressBook: '',
                    note: this.fv.tranNote.value,
                    amount: this.fv.amount.value,
                }
                localStorage.setItem('ach-state', JSON.stringify(state));
            },
            /* Validate input and go to transfer confirmation screen */
            goToConfirm(){
                this.transferDisplayAmount  = this.fv['amount'].value
                this.transferDisplayFrom =  this.fv['fromAccountId'].value
                this.transferDisplayTo =  this.fv['toAccountId'].value
        
                let success = true;
                let issue = '';
                let amt = parseFloat(this.transferDisplayAmount)

                if(this.accounts[this.transferDisplayFrom] != undefined){
                    this.transferDisplayAmountBeforeFrom = parseFloat(this.accounts[this.transferDisplayFrom].availableBalance)
                    this.transferDisplayAmountAfterFrom = parseFloat(this.accounts[this.transferDisplayFrom].availableBalance) - amt
                }
                
                    this.transferState = "confirm";
                    this.error = "";

            },
        /* Format a value for display */
        formatMoney(val){
            if(isNaN(parseFloat(val)))
                return '';
            return this.mon.format(val);
        },
        async fetchTransferOptions(){
            try{
                /*const r = await this.$mapi.get('transfer-options');
                let atr = r.data.data.attributes

                this.accounts = atr.accounts
                this.fromAccountIds = atr.fromAccountIds
                this.toAccountIdMap = atr.toAccountIdMap
                */
                //NCP demo account setting
                this.accounts = {
				"1": {
					"ownerName": "JOHNNY TEST ***310",
					"availableBalance": 7681.8,
					"actualBalance": 12381.8,
					"payoffBalance": null,
					"description": "ORIGINAL",
					"displayAccountId": "DRAFT-1",
					"type": "Checking",
					"external": false
				},
				"2": {
					"ownerName": "JOHNNY TEST ***310",
					"availableBalance": {
						"source": "0.0",
						"parsedValue": 0
					},
					"actualBalance": {
						"source": "0.0",
						"parsedValue": 0
					},
					"payoffBalance": null,
					"description": "ORIGINAL",
					"displayAccountId": "DRAFT-2",
					"type": "Checking",
					"external": false
				},
				"3": {
					"ownerName": "JOHNNY TEST ***310",
					"availableBalance": {
						"source": "0.0",
						"parsedValue": 0
					},
					"actualBalance": {
						"source": "0.0",
						"parsedValue": 0
					},
					"payoffBalance": null,
					"description": "ORIGINAL",
					"displayAccountId": "DRAFT-3",
					"type": "Checking",
					"external": false
				},
				"4": {
					"ownerName": "JOHNNY TEST ***310",
					"availableBalance": 10430.32,
					"actualBalance": 10660.32,
					"payoffBalance": null,
					"description": "MAIN SHARE 310",
					"displayAccountId": "SHARE-1",
					"type": "Savings",
					"external": false
				},
				"5": {
					"ownerName": "JOHNNY TEST ***310",
					"availableBalance": 16954.36,
					"actualBalance": 17179.36,
					"payoffBalance": null,
					"description": "CLUB 310",
					"displayAccountId": "SHARE-2",
					"type": "Savings",
					"external": false
				},
				"6": {
					"ownerName": "JOHNNY TEST ***310",
					"availableBalance": {
						"source": "500.0",
						"parsedValue": 500
					},
					"actualBalance": {
						"source": "0.0",
						"parsedValue": 0
					},
					"payoffBalance": null,
					"description": "****-****-****-3204",
					"displayAccountId": "CARD-04",
					"type": "CreditCard",
					"external": false,
					"nextPaymentAmount": {
						"source": "0.0",
						"parsedValue": 0
					}
				},
				"CHECK": {
					"ownerName": "OTHER",
					"availableBalance": null,
					"actualBalance": null,
					"payoffBalance": null,
					"description": "Mail check to address on file",
					"displayAccountId": "CHECK",
					"type": "Check",
					"external": false
				}}

                this.toAccountIdMap =  {
				"1": [
					"2",
					"3",
					"4",
					"5",
					"6"
				],
				"2": [
					"1",
					"3",
					"4",
					"5",
					"6"
				],
				"3": [
					"1",
					"2",
					"4",
					"5",
					"6"
				],
				"4": [
					"1",
					"2",
					"3",
					"5",
					"6",
					"CHECK"
				],
				"5": [
					"1",
					"2",
					"3",
					"4",
					"6",
					"CHECK"
				]
			};

            this.fromAccountIds = [
				"1",
				"2",
				"3",
				"4",
				"5"
			];



            }catch(ex){
                console.log("Transfer Options Load Catch: ", ex);  
            }
        }
    },
    setup(){        
        const state = ref("default");
        const modes = [
            { label: "Depost Money to my Account", value: "deposit" },
            { label: "Withdraw Money from my Account", value: "withdraw" },
            { label: "Make Loan Payment", value: "loan" }
        ]
        const freqs = [
            { label: "One Time", value: "once" },
            { label: "Weekly", value: "weekly" },
            { label: "Monthly", value: "monthly" },
            { label: "Semi-Annual", value: "semi-annual" },
            { label: "Annual", value: "annual" }
        ]
        const fromAccountIds = ref([])
        const accounts = ref([]);
        const toAccountIdMap = ref([]);

        let fv = {}
        fv["toAccountId"] = ref("-1")              
                
        fv["mode"] = ref("deposit");
        fv["paymentType"] = ref("both");
        fv["accountUser"] = ref("");
        fv["accountOther"] = ref("");
        fv["accountOtherType"] = ref("saved");
        fv["accountOtherSavedId"] = ref("");
        fv["accountOtherRouting"] = ref("");
        fv["accountOtherAccount"] = ref("");
        fv["accountOtherAccountConfirm"] = ref("");
        fv["accountOtherNickname"] = ref("");
        fv["fromAccountId"] = ref("-1");
        fv["accountOtherSave"] = ref(false);
        fv["amount"] = ref(0);
        fv["freq"] = ref("once");
        fv["freqStartDate"] = ref("");
        fv["tranNote"] = ref("");
        let transferState = ref('default')           //transferState: Current state screen is in
        let transferDisplayFrom = ref('')
        
        let mon                                      //mon: Used to format money
            = new Intl.NumberFormat('en-US', { style: 'currency', currency: 'USD' })

        return {
            accounts,
            freqs,
            fromAccountIds,
            fv,
            modes,
            state,
            mon,
            toAccountIdMap,
            transferState,
            transferDisplayFrom
        }
    }
}
</script>